export default __webpack_public_path__ + "static/media/cashout-icon-home-mobile.13b6e004.webp";